<div class="workSpace">
  <div class="headersTab">
    <div class="w3-quarter padreizquierda">
      <div class="w3-row hijoizquierda">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ "menu." + dataService.moduleSelect | translate }} </b> </span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ "menu." + dataService.subModuleSelect | translate }} </span>
      </div>
    </div>
    <div class="w3-quarter">
      <app-filters
        [name]="'filtros.periodo' | translate"
        [array]="periodos"
        [typeFilter]="Filters.PERIOD"
        (eventClick)="yearChange($event)"
        [click]="false"
      ></app-filters>
    </div>
    <div class="w3-quarter">
      <app-filters
        [name]="'filtros.sucursales' | translate"
        [array]="sucursales"
        [typeFilter]="Filters.SUCURSALES"
        [click]="false"
        [consolidado]="consolidado"
        (eventClick)="agencyChange($event)"
      >
      </app-filters>
    </div>
    <div class="w3-rest padreizquierda w3-right" style="height: 7vh; padding-top: 2vh; z-index: 100;">
        <div class="w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}"
          matTooltip="{{'tooltips.borrar-filtros'|translate}}">
          <img src="./../../../../assets/img/eraser.png">
        </div>
        <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}"
        [matMenuTriggerFor]="menu">
          more_vert
        </mat-icon>
        <mat-menu #menu="matMenu">
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarPDF()">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'menu.Exportar'|translate}}</span>
          </button>
        </mat-menu>
      </div>
  </div>
  <div class="workSpaceTab">
    <div class="tableZone">
      <div class="w3-row" style="height: 4%; width: 100%;">
        <div class="w3-half w3-titulo-contenidomenuSC">
          <span class="w3-margin-left-contenido">{{ 'comercial.asosiatividad.metas.encabezado' |translate}}</span>
        </div>
      </div>
      <div class="w3-row w3-scroll" style="height: 96%; width: 100%;">
        <table class="w3-table borderAllLow">
          <thead>
            <tr class="borderEncTop">
              <th class="stikyColumFillWhite1 borderEncRight borderEncLeft">{{'comercial.captacion.metas.encabezado-1-titulo-1' | translate}}</th>
              <th class="stikyColumFillLow1 borderEncRight w3-center w3-table-titleLow" colspan="3">{{'comercial.captacion.metas.encabezado-1-titulo-2' | translate}}</th>
              <th class="stikyColum1 borderEncRight w3-center w3-table-title" colspan="3">{{'comercial.captacion.metas.encabezado-1-titulo-3' | translate}}</th>
              <th class="stikyColumFillWhite1 borderEncRight w3-center w3-table-title-white" colspan="2"> {{'comercial.captacion.metas.encabezado-1-titulo-4' | translate}} </th>
            </tr>
            <tr class="borderEncTop">
              @for (enc of encabezados; track enc; let i = $index) {
                <th class="borderEncRight w3-center" 
                [ngClass]="{'w3-table-title stikyColum2': i>=1 && i<=3 || i>=7, 'stikyColumFillLow2 w3-table-titleLow': i>=4 && i<=6, 'w3-table-title-white borderEncLeft stikyColumFillWhite2': i==0}">
                  {{'comercial.captacion.metas.encabezado-2-titulo-'+(i+1) | translate}}
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (data of dataTable; track $index;) {
              <tr class="w3-table-trtd">
                @for (item of encabezados; track item; let i = $index) {
                  <td class="w3-center borderAllLow" [ngStyle]="i === 3 || i === 6 || i === 7 || i === 8  ? 
                  {'border-left': 'solid 8px', 'border-left-color': getBorderColor(data, i)} : null">
                    {{data['colum'+i]}}
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <div class="tarjetsZone">
      @for (tar of tarjets; track $index) {
        <div class="zonaTarjets">
          <app-tarjetas
          [header]="tar.header"
          [value]="tar.value"
          [footer]="tar.footer"
          [icon]="tar.icon"
          ></app-tarjetas>
        </div>
      }
    </div>
  </div>
</div>